<template>
  <v-container fluid color="white--text">
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Authentication</v-card-title>
          <v-card-text>
            <p>Sasa<span class="red--text">Pay</span> REST APIs use OAuth 2.0 access tokens to authenticate requests. Your access token authorizes you to use the Sasa<span class="red--text">Pay</span> REST API server.</p>
            <p>To call a REST API in your integration, you must exchange your client ID and secret for an access token. You can find your client ID and secret <a>Here</a></p>
            <p>You can make the API call in any programming language. The following examples show you how to get your access token using cURL or Postman.</p>
          </v-card-text>
          <v-divider/>
          <v-card-text>
            EndPoints:<br/>
            <div class="secondary pa-5" style="color: #e7e3fc">
              <strong>Sandbox</strong>
              <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/auth/token/?grant_type=client_credentials"}}</p>
            </div>
          </v-card-text>
          <v-divider/>
          <v-card-text>
            Request Parameters <br/>
            <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>CLIENT_ID</code> to your client ID. <br/>
            <v-icon color="primary">mdi-access-point-check</v-icon> Change <code>CLIENT_SECRET</code> to your secret. <br/>

          </v-card-text>
          <v-divider/>
          <v-card-text>
            Expected Results:<br/>

            Sasa<span class="red--text">Pay</span> returns an access token and the number of seconds the access token is valid. When you make calls to a REST API, include the access token in the Authorization header with the designation as Bearer. Reuse the access token until it expires.When your access token expires, call above /v1/oauth2/token again to request a new access token.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="">
        <h3>Sample Request</h3>
        <code-editor
            :read_only="true"
            theme="dark"
            v-model="code"
            @lang="changeLanguage"
            :wrap_code="false"
            :language_selector="true"
            class="github_dark"
            :copy_code="true"
            font_size="14px"
            height="50%"
            width="100%"
            :languages="languages"
        ></code-editor>
        <v-divider/>
        <h3>Sample Response</h3>
        <code-editor
            :read_only="true"
            theme="dark"
            v-model="response"
            :wrap_code="false"
            :language_selector="true"
            class="github_dark"
            :copy_code="true"
            font_size="14px"
            width="100%"
            :languages="[['json','JSON']]"
        ></code-editor>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {getAuthResponse, getCodeSnippets} from "../../../../../shared/snippets/JavaScript/auth";

export default {
  name: "Authentications",
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
    languages:[
      ['php','PHP'],['java','Java'],['python', 'Python'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']
    ]
  }),
  mounted() {
    this.importAuthSnippets('php')//
    this.importAuthResponse()
  },
  methods:{
    importAuthSnippets(lang){
      this.code=getCodeSnippets(lang)
    },
    importAuthResponse(){
      this.response=getAuthResponse()
    },
    //
    changeLanguage(val) {
      this.importAuthSnippets(val)
    }
  }
}
</script>

<style scoped>

</style>